import { GzLinkWebComponent } from './component/GzLinkWebComponent';
import { WEB_COMPONENT_GZ_LINK } from '../../webcomponents.constants';

export { GzLinkWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_LINK, GzLinkWebComponent);
